module.exports = __webpack_public_path__ + "img/nft.0fb97752.png";